import { AlertsController } from '../controller/AlertsController';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { AlertsNavigationParams } from '@nirvana/shared/navigation';
import { ColumnDetails, ColumnKeys, Target, ViewConfiguration } from '@nirvana/shared/dtos/types/alerts/common';

export class AlertsWebComponent extends BaseWebComponentElement {
  private _allColumns: Array<ColumnDetails>;
  private _defaultViewProps: ViewConfiguration;
  private _isPartner: boolean;
  private _filterKeys: ColumnKeys[];
  private _allDirectManagement?: Array<string>;
  private _defaultSelectedTargetIds: Array<string>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AlertsController,
    });
  }

  get currentViewId(): string {
    const value = this.getAttribute('data-current-view-id');
    return value ? value : '';
  }

  set currentViewId(value: string) {
    this.setAttribute('data-current-view-id', value);
  }

  set externalParams(value: AlertsNavigationParams) {
    this.setAttribute('data-external-params', JSON.stringify(value));
  }

  get externalParams(): AlertsNavigationParams {
    const value = this.getAttribute('data-external-params');
    return value ? JSON.parse(value) : {};
  }

  set allColumns(allColumns: Array<ColumnDetails>) {
    this._allColumns = allColumns;
  }

  get allColumns(): Array<ColumnDetails> {
    return this._allColumns ?? [];
  }

  set defaultViewProps(defaultViewProps: ViewConfiguration) {
    this._defaultViewProps = defaultViewProps;
  }

  get defaultViewProps(): ViewConfiguration {
    return this._defaultViewProps ?? {};
  }

  set isPartner(value: boolean) {
    this._isPartner = value;
  }

  get isPartner(): boolean {
    return this._isPartner ?? false;
  }

  get filterKeys(): ColumnKeys[] {
    return this._filterKeys;
  }

  set filterKeys(value: ColumnKeys[]) {
    this._filterKeys = value;
  }

  get allDirectManagement(): Array<string> | undefined {
    return this._allDirectManagement;
  }

  set allDirectManagement(value: Array<string> | undefined) {
    this._allDirectManagement = value;
  }

  public get defaultSelectedTargetIds(): Array<string> {
    return this._defaultSelectedTargetIds;
  }

  public set defaultSelectedTargetIds(value: Array<string>) {
    this._defaultSelectedTargetIds = value;
  }
}
